import { useEffect, useState } from 'react';
import { useIndexedDB } from 'react-indexed-db-hook';

import { useOnlineStatusDetector } from './useOnlineStatusDetector';

export const useOfflineImage = (url) => {
  const [imageSrc, setImageSrc] = useState(null);
  const { getAll } = useIndexedDB('image');
  const { isOnline } = useOnlineStatusDetector();

  useEffect(() => {
    const fetchImage = async () => {
      const allImages = await getAll();
      const imageRecord = allImages.find((img) => img.url === url);

      if (!imageRecord) return;

      const imageBlob = new Blob([imageRecord.file]);
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImageSrc(imageObjectURL);
    };

    fetchImage();
  }, [url]);

  return isOnline ? null : imageSrc;
};
